export default () => ({
  registraties: [],
  registratie: {}
});
